// extracted by mini-css-extract-plugin
module.exports = {"menu_divider":"styles_menu_divider__SV3bD"};